import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import CombineRollbackForm from '@/components/DailyReportEdit/CombineRollback/CombineRollbackForm.vue';
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import AlterReturningForm from '@/components/DailyReportEdit/AlterReturning/AlterReturningForm.vue';
import AlterLeavingForm from '@/components/DailyReportEdit/AlterLeaving/AlterLeavingForm.vue';
import SplitForm from '@/components/DailyReportEdit/Split/SplitForm.vue';
import MergeForm from '@/components/DailyReportEdit/Merge/MergeForm.vue';
import RecreateForm from '@/components/DailyReportEdit/Recreate/RecreateForm.vue';
import CombineForm from '@/components/DailyReportEdit/Combine/CombineForm.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import { useRoute, useRouter } from 'vue-router';
import { ref, Ref, onMounted } from 'vue';
import {
  PATH_SUFFIX_ALTER_LEAVING,
  PATH_SUFFIX_ALTER_RETURNING,
  PATH_SUFFIX_DIVIDE,
  PATH_SUFFIX_MERGE,
  PATH_SUFFIX_RECREATE,
  PATH_SUFFIX_COMBINE,
  PATH_SUFFIX_COMBINE_ROLLBACK,
} from '@/services/consts/daily_report';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyReportEdit',
  props: {
    switchContentLoading: { type: Function },
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const { loginWithRedirect } = useAuth();
const route = useRoute();
const router = useRouter();
const path = route.path;
const splitPath = path.split('/');
const pathSuffix = splitPath[splitPath.length - 1];
const deliveryPlanId: string = route.params.id as string;
const deliveryPlan = ref({} as getDeliveryPlanVehicleInformation);
const isDisplaySplit: Ref<boolean> = ref(false);
const isDisplayMerge: Ref<boolean> = ref(false);
const isDisplayAlterReturning: Ref<boolean> = ref(false);
const isDisplayAlterLeaving: Ref<boolean> = ref(false);
const isDisplayRecreate: Ref<boolean> = ref(false);
const isDisplayCombine: Ref<boolean> = ref(false);
const isDisplayCombineRollback: Ref<boolean> = ref(false);

onMounted(() => {
  props.switchContentLoading(true);
  setDocumentTitle();
  getDeliveryPlan();
});

function getDeliveryPlan() {
  Api().getDeliveryPlan(deliveryPlanId).then((data: getDeliveryPlanVehicleInformation) => {
    deliveryPlan.value = data;
    isViewableThisPage(data.editable_actions);
  }).catch((error) => {
    errorHandler(error);
  }).finally(() => {
    if (pathSuffix != PATH_SUFFIX_MERGE) {
      props.switchContentLoading(false);
    }
  });
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      location.reload()
      break
  }
}

function setDocumentTitle() {
  switch (pathSuffix) {
    case PATH_SUFFIX_ALTER_RETURNING:
      document.title = i18n.global.t('pages.dailyReports.alterLeavingOrReturning.returningTitle');
      break;
    case PATH_SUFFIX_ALTER_LEAVING:
      document.title = i18n.global.t('pages.dailyReports.alterLeavingOrReturning.leavingTitle');
      break;
    case PATH_SUFFIX_DIVIDE:
      document.title = i18n.global.t('pages.dailyReports.splitForm.title');
      break;
    case PATH_SUFFIX_MERGE:
      document.title = i18n.global.t('pages.dailyReports.mergeForm.title');
      break;
    case PATH_SUFFIX_RECREATE:
      document.title = i18n.global.t('pages.dailyReports.recreateForm.title');
      break;
    case PATH_SUFFIX_COMBINE:
      document.title = i18n.global.t('pages.dailyReports.combineForm.title');
      break;
    case PATH_SUFFIX_COMBINE_ROLLBACK:
      document.title = i18n.global.t('pages.dailyReports.combineRollbackForm.title');
      break;
  }
}

function isViewableThisPage(actions: getDeliveryPlanVehicleInformation['editable_actions']) {
  switch (pathSuffix) {
    case PATH_SUFFIX_ALTER_RETURNING:
      if (!actions?.alter_returning?.available) {
        router.push({ name: "DailyReport" })
      }
      isDisplayAlterReturning.value = true;
      break;
    case PATH_SUFFIX_ALTER_LEAVING:
      if (!actions?.alter_leaving?.available) {
        router.push({ name: "DailyReport" })
      }
      isDisplayAlterLeaving.value = true;
      break;
    case PATH_SUFFIX_DIVIDE:
      if (!actions?.divide?.available) {
        router.push({ name: "DailyReport" })
      }
      isDisplaySplit.value = true;
      break;
    case PATH_SUFFIX_MERGE:
      if (!actions?.merge?.available) {
        router.push({ name: "DailyReport" })
      }
      isDisplayMerge.value = true;
      break;
    case PATH_SUFFIX_RECREATE:
      if (!actions?.recreate?.available) {
        router.push({ name: "DailyReport" })
      }
      isDisplayRecreate.value = true;
      break;
    case PATH_SUFFIX_COMBINE:
      if (!actions?.combine?.available || !deliveryPlan.value.driver) {
        return router.push({ name: "DailyReport" })
      }
      isDisplayCombine.value = true;
      break;
    case PATH_SUFFIX_COMBINE_ROLLBACK:
      if (!actions?.combine_rollback?.available) {
        router.push({ name: "DailyReport" })
      }
      isDisplayCombineRollback.value = true;
      break;
  }
}

return (_ctx: any,_cache: any) => {
  return (isDisplaySplit.value)
    ? (_openBlock(), _createBlock(SplitForm, {
        key: 0,
        deliveryPlanId: _unref(deliveryPlanId),
        deliveryPlan: deliveryPlan.value,
        showFlash: props.showFlash
      }, null, 8, ["deliveryPlanId", "deliveryPlan", "showFlash"]))
    : (isDisplayMerge.value)
      ? (_openBlock(), _createBlock(MergeForm, {
          key: 1,
          deliveryPlanId: _unref(deliveryPlanId),
          deliveryPlan: deliveryPlan.value,
          switchContentLoading: props.switchContentLoading,
          showFlash: props.showFlash
        }, null, 8, ["deliveryPlanId", "deliveryPlan", "switchContentLoading", "showFlash"]))
      : (isDisplayAlterLeaving.value)
        ? (_openBlock(), _createBlock(AlterLeavingForm, {
            key: 2,
            deliveryPlan: deliveryPlan.value,
            showFlash: props.showFlash
          }, null, 8, ["deliveryPlan", "showFlash"]))
        : (isDisplayAlterReturning.value)
          ? (_openBlock(), _createBlock(AlterReturningForm, {
              key: 3,
              deliveryPlan: deliveryPlan.value,
              showFlash: props.showFlash
            }, null, 8, ["deliveryPlan", "showFlash"]))
          : (isDisplayRecreate.value)
            ? (_openBlock(), _createBlock(RecreateForm, {
                key: 4,
                deliveryPlan: deliveryPlan.value,
                showFlash: props.showFlash
              }, null, 8, ["deliveryPlan", "showFlash"]))
            : (isDisplayCombine.value)
              ? (_openBlock(), _createBlock(CombineForm, {
                  key: 5,
                  deliveryPlan: deliveryPlan.value,
                  showFlash: props.showFlash
                }, null, 8, ["deliveryPlan", "showFlash"]))
              : (isDisplayCombineRollback.value)
                ? (_openBlock(), _createBlock(CombineRollbackForm, {
                    key: 6,
                    deliveryPlan: deliveryPlan.value,
                    showFlash: props.showFlash
                  }, null, 8, ["deliveryPlan", "showFlash"]))
                : _createCommentVNode("", true)
}
}

})